function getInnerHtmlBtn(isShowed, hiddenText, showedText) {
  return `${!isShowed ? showedText : hiddenText}`;
}

function showMoreContent(event) {
  const button = event.currentTarget;
  const { idTable, idHiddenItem } = button.dataset;
  const isShowed = button.classList.contains('showed');
  const selector = isShowed ? `.${idHiddenItem}` : `.${idHiddenItem}.hide`;

  document.querySelectorAll(`.${idTable} ${selector}`).forEach((row) => {
    row.classList.toggle('hide');
  });

  document.querySelectorAll(`.ac-btn-plus[data-id-table=${idTable}]`).forEach((btn) => {
    const newBtn = btn;
    newBtn.classList.toggle('showed');
    newBtn.innerHTML = getInnerHtmlBtn(isShowed, newBtn.dataset.hiddenText, newBtn.dataset.showedText);
  });

  if (window.iframeResizer) {
    window.iframeResizer();
  }
}

function init() {
  document.querySelectorAll('.ac-btn-plus').forEach((button) => {
    button.addEventListener('click', showMoreContent);
  });
}

export default init;
